"use client";
import { apps } from "./deploy/apps";
import { customDomains } from "./deploy/custom-domains";
import { deployments } from "./deploy/deployments";
import { domains } from "./deploy/domains";
import { envVars } from "./deploy/env-vars";
import { environmentSettings } from "./deploy/environment-settings";
import { environments } from "./deploy/environments";
import { policies } from "./deploy/policies";
import { projects } from "./deploy/projects";

// Export types
export type { App } from "./deploy/apps";
export type { CustomDomain } from "./deploy/custom-domains";
export type { DeploymentStatus } from "./deploy/deployment-status";
export { DEPLOYMENT_STATUSES } from "./deploy/deployment-status";
export type { Deployment } from "./deploy/deployments";
export type { Domain } from "./deploy/domains";
export type { EnvVar } from "./deploy/env-vars";
export type { EnvironmentSettings } from "./deploy/environment-settings";
export type { Project } from "./deploy/projects";
export type { PolicyRow } from "./deploy/policies";
export type { Policy, PolicyType } from "./deploy/policies.schema";
export type { Environment } from "./deploy/environments";

// Global collections
export const collection = {
  projects,
  apps,
  environments,
  domains,
  deployments,
  customDomains,
  environmentSettings,
  envVars,
  policies,
} as const;

export async function reset() {
  // Clean up all global collections
  await Promise.all(Object.values(collection).map((c) => c.cleanup()));
  // Preload global collections after cleanup
  await Promise.all(Object.values(collection).map((c) => c.preload()));
}
